import TransLoco from 'shared/components/trans-loco'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'

export const useFormErrorMessageInTabs = () => {
  const { t, tICU } = useLocoTranslation()

  const formErrorMessage = ({
    tabsErrorsMap,
    tabsLocoKeys,
  }: {
    tabsErrorsMap: Record<string, boolean>
    tabsLocoKeys: Record<string, string>
  }) => {
    const tabsWithErrors = Object.entries(tabsErrorsMap)
      .filter(([, hasError]) => hasError)
      .map(([tab]) => tab)

    const errorMessage = tabsWithErrors.length ? (
      <TransLoco
        t={key => {
          if (!key) return
          return tICU(key, {
            tabs: tabsWithErrors.map(tab => `"${t(tabsLocoKeys[tab])}"`).join(', '),
            tabsCount: tabsWithErrors.length,
            b: elem => `<b>${elem.join()}</b>`,
          })
        }}
        i18nKey="dashboard.store.error.check_following_errors_in_tab"
        components={{
          b: <b />,
        }}
      />
    ) : null

    return {
      errorMessage,
    }
  }

  return {
    formErrorMessage,
  }
}
